import {  useAuth0 } from "@auth0/auth0-react";
import React from 'react'
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {Link} from "react-router-dom";
import Ad from "./Ads";
const Card = ({ productData }) => {
 
  const [searchText, setSearchText] = useState("");

  const { user,isAuthenticated  } = useAuth0();
  productData = productData && productData.filter(
    ({ name,category}) =>
      name.toLowerCase().includes(searchText.toLowerCase())||
      category.toLowerCase().includes(searchText.toLowerCase())
      
  );
  const result = productData.length;
  const searchBar = document.getElementById("searchBar");
  const [isActive, setIsActive] = useState(false);
  function handleClick() {
    setIsActive(!isActive);
  }
  

  return (
    <>
    
    <Helmet>
    <title>DesireStore - Secure and Fast Software, Games, Android APKs, Bookmarker and Link Library</title>
<meta name="title" content="DesireStore - Secure and Fast Software, Games, Android APKs, Bookmarker and Link Library"/>
<meta name="description" content="DesireStore offers secure and fast downloads for software, games, Android APKs, and other useful tools like a bookmarking feature and link library. Find everything you need at DesireStore."/>

<meta property="og:type" content="website"/>
<meta property="og:url" content="https://desirestore.online/"/>
<meta property="og:title" content="DesireStore - Secure and Fast Software, Games, Android APKs, Bookmarker and Link Library"/>
<meta property="og:description" content="DesireStore offers secure and fast downloads for software, games, Android APKs, and other useful tools like a bookmarking feature and link library. Find everything you need at DesireStore."/>
<meta property="og:image" content="https://desirestore.online/og-images/og-home.png"/>

<meta property="twitter:card" content="summary_large_image"/>
<meta property="twitter:url" content="https://desirestore.online/"/>
<meta property="twitter:title" content="DesireStore - Secure and Fast Software, Games, Android APKs, Bookmarker and Link Library"/>
<meta property="twitter:description" content="DesireStore offers secure and fast downloads for software, games, Android APKs, and other useful tools like a bookmarking feature and link library. Find everything you need at DesireStore."/>
<meta property="twitter:image" content="https://desirestore.online/og-images/og-home.png"/>
<link rel='cononical' href="https://desirestore.online/" />

      </Helmet>
    
    <div className="container">
      <div className="hero">
        <div className="left-hero">
          <h3>Your One-Stop-Shop for <span id="home">!</span></h3>
         <h1>Get Ready to Download Anything <br /> You Need with <span id="title"> Desire Store </span> today</h1>
          <p>We are Not Just Software Downloding</p>
        </div>
        <div className="right-hero">
        <div className={`search ${isActive ? '' : 'active'}`}>
          <div className="icon" onClick={handleClick}></div>
          <div className="input">  <input type="search" id="searchBar" placeholder="Search Products..." onChange={(e) => setSearchText(e.target.value)} /></div> 
          
          </div>
<p style={{ display: searchBar && searchBar.value ? "block" : "none" }}>( {result} Results Found)</p>
</div> </div>
      <div id="notfound"style={{ display: productData.length === 0 && searchText !== "" ? "block" : "none" }} >
       <div className="notfound">
         <h2>Sorry, this item is unavailable right now </h2>
          <div className="notfound-404">
            <h1>Oops!</h1>
            <h2>This item not found</h2>
          </div>
          <Link to="/contact">Request Software</Link>
        </div>
      </div>

      
      {
  productData.map((curElem) => {
    const {id, name, link, image, size, sizeSmall} = curElem;
    
    return (
      <React.Fragment key={id}>
        <div className="Product">       
          <div className="card">
            <div className="imgBox">
              <img src={image} alt={name} className="mouse"/>
            </div>  
            <div className="contentBox">
              <h3>{name}</h3>
              <h2 className="price">{size}.<small>{sizeSmall}</small> GB</h2>
              <a href={link} className="buy">Download</a>
            </div>
          </div>
        </div>
        <Ad  />
      </React.Fragment>
    );
  })
}
        <div className="notification">
    <p>welcome back,{isAuthenticated ? (user ? user.nickname : "") : "user"}</p>
    <div className="notification-progress"></div>
  </div>
    </div>
  </>
  )}  

export default Card

